import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { CheckProvider } from '../../providers/check/check';

@Component({
  selector: 'page-user-history',
  templateUrl: 'user-history.html',
})
export class UserHistoryPage {

  checks;
  date;
  
  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public checkProvider: CheckProvider
  ) {
      this.date = new Date().toISOString();
      this.loadChecks();
  }

  loadChecks() {
    if(this.date) {
      let loading = this.loadingCtrl.create();
      loading.present();
      this.checks = this.checkProvider.getUserChecks(new Date(this.date));
      loading.dismiss();
    } 
    
    else this.showMessage(`Debe indicar una fecha`);
  }
    
  ubication(check) {
    if(check.coords) this.navCtrl.push('MapPage', { mode: 'check', check: check });
    else this.showMessage(`Este fichaje se ha añadido manualmente o mediante de un fichador.`);
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-history/user-history.ts